import { getCookie } from './utils';
import { UTM } from '../dwh-tracking/types';
import { isJsonString } from '../../common/util';

const UTMZ_MAGIC_PREFIX = '137333551.1402566678.4.2.';

export function getUtmCookieValues(): UTM {
    const utmCookieValue = getCookie('NIKE-UTMZ') || '';

    if (!utmCookieValue) {
        return null;
    }

    const decodeCookie = decodeURIComponent(utmCookieValue).replace(UTMZ_MAGIC_PREFIX, '');
    const cookieString = '{"' + decodeCookie.replaceAll('|', '","').replaceAll(/=/g, '":"') + '"}';

    if (!isJsonString(cookieString)) {
        return null;
    }

    const cookieObject = JSON.parse(cookieString, function(key, value) {
        return key === '' ? value : decodeURIComponent(value);
    });

    return {
        utmSource: cookieObject['utmcsr'],
        utmCampaign: cookieObject['utmccn'],
        utmMedium: cookieObject['utmcmd'],
        utmTerm: cookieObject['utmctr'],
        utmContent: cookieObject['utmcct']
    };
}
